module.exports = __webpack_public_path__ + "img/dashboard.90c25cc5.png";